/**
 * Date che arrivano dal server.
 *
 * Il backend salva in UTC e spesso risponde senza fuso («2026-10-02T09:46:39»,
 * a volte con lo spazio di SQLite). `new Date()` legge quella stringa come ora
 * LOCALE: in Italia d'estate ogni orario mostrato risultava due ore
 * indietro. Qui una data-ora senza fuso si interpreta come UTC; una stringa che
 * il fuso lo dichiara («Z», «+00:00») e una data senza ora restano come sono.
 */
const HAS_ZONE = /(?:[zZ]|[+-]\d{2}:?\d{2})$/;
const NAIVE_DATETIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/;

export function parseApiDate(iso: string): Date {
  const s = iso.trim();
  if (!HAS_ZONE.test(s) && NAIVE_DATETIME.test(s)) return new Date(s.replace(" ", "T") + "Z");
  return new Date(s);
}
